import styled from 'styled-components';

export const Container = styled.div`
    padding: 83px 0px;
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
`;